import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailIcon from '@mui/icons-material/Mail';
import './header.css';
import templeJson from '../../../../config/temple.json';
import { Link } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useTheme, useMediaQuery } from "@mui/material";

import { Grid, IconButton } from '@mui/material';

function TopHeader() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  let SvtHeader = `${process.env.REACT_APP_S3_BASE_URL}/api/images/header4.png`;
  if (isMobile) {
    SvtHeader = `${process.env.REACT_APP_S3_BASE_URL}/api/images/mobile_header.png`;
  } else if (isTablet) {
    SvtHeader = `${process.env.REACT_APP_S3_BASE_URL}/api/images/tab_header.png`;
  }
  return (
    <>
      <Grid className={templeJson['Header'].style == 1 ? 'dt-header' : 'svt-header'} sx={{

      }}>
        {templeJson['Header'].style == 1 ? (
          <>
            <Grid container className="gx-0">
              <Grid item lg={6} className="text-center text-lg-start mb-lg-0">
                <Grid className="d-flex flex-wrap">
                  <Link to="/" className="text-light me-4 topheader-link">
                    <LocationOnIcon className="top-icon" /> {templeJson['templeAddress']}
                  </Link>
                  <Link to="/" className="text-light me-0 topheader-link">
                    <MailIcon className="top-icon" /> {templeJson['contactEmail']}
                  </Link>
                </Grid>
              </Grid>
              <Grid item lg={6}>
                <Grid container direction="row" spacing={1} justifyContent="flex-end">
                  <Grid item>
                    <IconButton
                      className="top-icon"
                      component="a"
                      href={templeJson['youtubeLink']}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="YouTube"
                    >
                      <YouTubeIcon />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      className="top-icon"
                      component="a"
                      href={templeJson['facebookLink']}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Facebook"
                    >
                      <FacebookIcon />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      className="top-icon"
                      component="a"
                      href={templeJson['instagramLink']}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Instagram"
                    >
                      <InstagramIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          <Grid>
            <Link to="/">
              <Grid
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Grid
                  component="img"
                  src={SvtHeader}
                  alt="logo"
                  sx={{
                    width: '100%',
                    display: 'block'
                  }}
                />
              </Grid>
            </Link>
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default TopHeader;
